// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__LiSAt","emails":"CreateEditClinics_emails__38pm0","emailTagLabel":"CreateEditClinics_emailTagLabel__141k1"};